import { useContext } from "react";
import { priceConfigurationContext } from "./PriceConfigurationContextProvider";

const usePriceConfigurationContext = () => {
  return useContext(priceConfigurationContext);
};

export default usePriceConfigurationContext;
